export const POUR_AVAILABILITY_ENTITY_TYPE = {
    Category: 'Category',
    ProductType: 'ProductType',
    ProductSubtype: 'ProductSubtype',
    Drink: 'Drink',
    ProductLine: 'ProductLine',
    Product: 'Product',
} as const;

export type PourAvailabilityEntityType =
    (typeof POUR_AVAILABILITY_ENTITY_TYPE)[keyof typeof POUR_AVAILABILITY_ENTITY_TYPE];
